import _cookies from "./_cookies.js";
import _loremIpsum from "./_lorem-ipsum.js";
import _months from "./_months.js";

export default {
    ..._loremIpsum,
    ..._months,
    ..._cookies,

    Home: { en: "Home", uk: "Головна" },
    Subscribe: { en: "Subscribe", uk: "Підписатися" },
    Upgrade: { en: "Upgrade", uk: "Покращити" },
    Downgrade: { en: "Downgrade", uk: "Понизити" },
    Selected: { en: "Selected", uk: "Обраний" },
    Buy: { en: "Buy", uk: "Придбати" },
    Offers: { en: "Offers", uk: "Пропозиції" },
    month: { en: "month", uk: "місяць" },
    month_short: { en: "mo", uk: "міс" },
    Generate: { en: "Generate", uk: "Згенерувати" },
    GetInTouchText: { en: "Have any questions left?", uk: "Залишились питання?" },
    GetInTouch: { en: "Get In Touch", uk: "Зв'яжіться з нами" },
};
